export default __webpack_public_path__ + "static/media/Edge.da6f25ee.svg";